export const zoomStyle =  {
	fontSize: "10px",
	transform: "scale(0.8)",
	width: "125%"
}

export function setArray(array, max, copyArray, idx) {
	max = idx == 0 ? max - 1 : max;
	if (array.length >= max) {
		return array.splice(0);
	} else {
		while (array.length < max - 4) {
			array.push(JSON.parse(JSON.stringify(copyArray)));
		}
		return array;
	}
}

export function setInfo2() {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						textStyle: zoomStyle,
						width: null,
						text: `款号`,
						propsName: 'colorName'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `系列`,
						propsName: 'series'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `订单类型`,
						propsName: 'standard'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `货品名称`,
						propsName: 'attrSpecificationsAndDensity'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `合同期`,
						propsName: 'attrConstituent'
					},
					// {
					// 	textStyle: zoomStyle,
					// 	width: null,
					// 	text: `商品期`,
					// 	propsName: 'productDate'
					// },
					{
						textStyle: zoomStyle,
						width: null,
						text: `实际到仓日期`,
						propsName: 'unit'
					},
					{
						textStyle: zoomStyle,
						width: null,
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '10%',
							// height: '24mm'
						},
						// contentStyle: { flex: "none", width: "20%" },
						children: [
							{

								textStyle: zoomStyle,
								width: null,
								text: '涉扣款物料'
							},
							{
								children: [
									{
										textStyle: {
											...zoomStyle,
											lineHeight: '13px'
										},
										text: `物料编号`,
										propsName: 'taxFinishPrice1'
									},
									{
										textStyle: {
											...zoomStyle,
											lineHeight: '13px'
										},
										text: `供应商`,
										propsName: 'taxFinishPrice2'
									},
									{
										textStyle: {
											...zoomStyle,
											lineHeight: '13px'
										},
										text: `物料合同期`,
										propsName: 'taxFinishPrice3'
									},
									{
										textStyle: {
											...zoomStyle,
											lineHeight: '13px'
										},
										text: `实际到仓时间`,
										propsName: 'taxFinishPrice3'
									}
								]
							}
						]
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `零售价（元）`,
						propsName: 'templateCycle'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `FOB价（元）`,
						propsName: 'templateCycle'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `订单数量（件）`,
						propsName: 'shipmentDate'
					},
					{
						textStyle: zoomStyle,
						width: null,
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '10%',
							// height: '24mm'
						},
						// contentStyle: { flex: "none", width: "20%" },
						children: [
							{
								textStyle: zoomStyle,
								width: null,
								text: '入仓数（件）'
							},
							{
								children: [
									{
										textStyle: zoomStyle,
										text: `正品`,
										propsName: 'taxFinishPrice1'
									},
									{
										textStyle: zoomStyle,
										text: `二等品`,
										propsName: 'taxFinishPrice2'
									},
									{
										textStyle: zoomStyle,
										text: `次品`,
										propsName: 'taxFinishPrice2'
									},
									{
										textStyle: zoomStyle,
										text: `总数`,
										propsName: 'taxFinishPrice2'
									},
								]
							}
						]
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `扣款事由`,
						propsName: 'shipmentDate'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `扣款数量（件）`,
						propsName: 'shipmentDate'
					},
					{
						width: null,
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '8%',
							// height: '24mm'
						},
						// contentStyle: { flex: "none", width: "20%" },
						children: [
							{
								textStyle: zoomStyle,
								width: null,
								text: '应扣款'
							},
							{
								children: [
									{
										textStyle: zoomStyle,
										text: `单价`,
										propsName: 'taxFinishPrice1'
									},
									{
										textStyle: zoomStyle,
										text: `总金额`,
										propsName: 'taxFinishPrice2'
									},
								]
							}
						]
					},
					{
						width: null,
						style: {
							flexDirection: "column",
							flex: 'none',
							width: '8%',
							// height: '24mm'
						},
						// contentStyle: { flex: "none", width: "20%" },
						children: [
							{
								textStyle: zoomStyle,
								width: null,
								text: '申请扣款'
							},
							{
								children: [
									{
										textStyle: zoomStyle,
										text: `单价`,
										propsName: 'taxFinishPrice1'
									},
									{
										textStyle: zoomStyle,
										text: `总金额`,
										propsName: 'taxFinishPrice2'
									},
								]
							}
						]
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `申请免扣（少扣）金额`,
						propsName: 'shipmentDate'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `责任方`,
						propsName: 'shipmentDate'
					},
					{
						textStyle: zoomStyle,
						style: {
							width: "40mm",
							flex: "none"
						},
						width: null,
						text: `备注`,
					},
				]
			}
		]
	}
}


export const copySetInfo2 = {
	style: {
		height: "20mm",
		flex: "none"
	},
	children: [
		{
			width: null,
			text: ``,
			propsName: 'colorName'
		},
		{
			width: null,
			text: ``,
			propsName: 'vendorMaterialCode'
		},
		{
			width: null,
			text: ``,
			propsName: 'standard'
		},
		{
			width: null,
			text: ``,
			propsName: 'attrSpecificationsAndDensity'
		},
		{
			width: null,
			text: ``,
			propsName: 'attrConstituent'
		},
		// {
		// 	width: null,
		// 	text: ``,
		// 	propsName: 'productDate'
		// },
		{
			width: null,
			text: ``,
			propsName: 'unit'
		},
		{
			width: null,
			style: {
				flexDirection: "row",
				flex: 'none',
				width: '10%',
				// height: '24mm'
			},
			// children: [
			// {
			// 	width: null,
			text: ``,
			// },
			// {
			children: [
				{
					text: ``,
					propsName: 'taxFinishPrice1'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice3'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice3'
				}
			]
			// 	}
			// ]
		},
		{
			width: null,
			text: ``,
			propsName: 'templateCycle'
		},
		{
			width: null,
			text: ``,
			propsName: 'fobPrice'
		},
		{
			width: null,
			text: ``,
			propsName: 'shipmentDate'
		},
		{
			width: null,
			style: {
				flexDirection: "row",
				flex: 'none',
				width: '10%',
				// height: '24mm'
			},
			// contentStyle: { flex: "none", width: "20%" },
			// children: [
			// {
			// 	width: null,
			text: ``,
			// },
			// {
			children: [
				{
					text: ``,
					propsName: 'taxFinishPrice1'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
			]
			// }
			// ]
		},
		{
			width: null,
			text: ``,
			propsName: 'shipmentDate'
		},
		{
			width: null,
			text: ``,
			propsName: 'shipmentDate'
		},
		{
			width: null,
			style: {
				flexDirection: "row",
				flex: 'none',
				width: '8%',
				// height: '24mm'
			},
			// contentStyle: { flex: "none", width: "20%" },
			// children: [
			// 	{
			// 		width: null,
			text: ``,
			// 	},
			// 	{
			children: [
				{
					text: ``,
					propsName: 'taxFinishPrice1'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
				// ]
				// }
			]
		},
		{
			width: null,
			style: {
				flexDirection: "row",
				flex: 'none',
				width: '8%',
				// height: '24mm'
			},
			// contentStyle: { flex: "none", width: "20%" },
			// children: [
			// {
			// 	width: null,
			text: ``,
			// },
			// {
			children: [
				{
					text: ``,
					propsName: 'taxFinishPrice1'
				},
				{
					text: ``,
					propsName: 'taxFinishPrice2'
				},
			]
			// }
			// ]
		},
		{
			width: null,
			text: ``,
			propsName: 'shipmentDate'
		},
		{
			width: null,
			text: ``,
			propsName: 'shipmentDate'
		},
		{
			style: {
				width: "40mm",
				flex: "none"
			},
			width: null,
			text: ``,
		},
	]
}


export function setInfo3() {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				style:{
					height:'10mm'
				},
				children: [
					{
						textStyle: zoomStyle,
						style: {
							width: "50mm",
							flex: "none"
						},
						width: null,
						text: `款号`,
						propsName: 'colorName'
					},
					{
						textStyle: zoomStyle,
						style: {
							width: "80mm",
							flex: "none"
						},
						width: null,
						text: `加工厂回复意见`,
						propsName: 'vendorMaterialCode'
					},
					{
						textStyle: zoomStyle,
						style: {
							width: "80mm",
							flex: "none"
						},
						width: null,
						text: `跟单补充意见`,
						propsName: 'vendorMaterialCode'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `业务意见处理`,
						propsName: 'standard'
					},
					{
						textStyle: zoomStyle,
						width: null,
						text: `赫基生管意见`,
						propsName: 'attrSpecificationsAndDensity'
					},
					// {
					// 	textStyle: {
					// 		fontSize: "10px",
					// 		transform: "scale(0.6)",
					// 		width: "160%",
					// 	},
					// 	width: null,
					// 	text: `统计审核意见`,
					// 	propsName: 'attrSpecificationsAndDensity'
					// },
					{
						textStyle: zoomStyle,
						width: '60mm',
						text: `备注`,
						propsName: 'attrSpecificationsAndDensity'
					}
				]
			}
		]
	}
}

export const copySetInfo3 = {
	style: {
		height: "32mm",
		flex: "none"
	},
	children: [
		{
			textStyle: zoomStyle,
			style: {
				width: "50mm",
				flex: "none"
			},
			width: null,
			text: ``,
			propsName: 'colorName'
		},
		{
			textStyle: zoomStyle,
			style: {
				width: "80mm",
				flex: "none"
			},
			width: null,
			text: ``,
			propsName: 'vendorMaterialCode'
		},
		{
			textStyle: zoomStyle,
			style: {
				width: "80mm",
				flex: "none"
			},
			width: null,
			text: ``,
			propsName: 'vendorMaterialCode'
		},
		{
			textStyle: zoomStyle,
			width: null,
			text: ``,
			propsName: 'standard'
		},
		{
			textStyle: zoomStyle,
			width: null,
			text: ``,
			propsName: 'attrSpecificationsAndDensity'
		},
		// {
		// 	textStyle: {
		// 		fontSize: "10px",
		// 		transform: "scale(0.6)",
		// 		width: "160%",
		// 	},
		// 	width: null,
		// 	text: ``,
		// 	propsName: 'attrSpecificationsAndDensity'
		// },
		{
			textStyle: zoomStyle,
			width: '60mm',
			text: ``,
			propsName: 'attrSpecificationsAndDensity'
		}
	]

}